import { render, staticRenderFns } from "./AuthBootstrap.vue?vue&type=template&id=05be5345&scoped=true"
import script from "./AuthBootstrap.vue?vue&type=script&lang=js"
export * from "./AuthBootstrap.vue?vue&type=script&lang=js"
import style0 from "./AuthBootstrap.vue?vue&type=style&index=0&id=05be5345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be5345",
  null
  
)

export default component.exports